






























































import Vue from 'vue';
import {
  Evento,
  SeguimientoData,
  CarActualPosition,
  TrackerPosition,
  Direccion,
  EventoSeguimientoSSE,
  mapEventoSSEToEvento,
  mapEventoSSEToTrackerPosition,
  mapEventoSSEToCarActualPosition,
  mapDriverEventIdToEventType,
} from '@/models/requests-and-responses/seguimiento';
import { get, INSERVER_BASE_URL } from '@/services/http';
import NoPhone from '@/components/no-phone/NoPhone.vue';
import { DireccionesDistanciasReq } from '@/models/requests-and-responses/direcciones';
import { getUserProperties } from '@/services/api/firebaseApi';
import IconAlert from '@/components/icons/IconAlert.vue';
import LoadingFullscreen from '../LoadingFullscreen.vue';
import MainTrackingMobile from './MainTrackingMobile.vue';
import MainTrackingDesktop from './MainTrackingDesktop.vue';
import TrackingSupportButton from './components/TrackingSupportButton.vue';

// En vez de 'any' esto debería ser de tipo NodeJS.Timeout, pero no sé cómo importarlo.
type NodeJSTimeout = any;

export default Vue.extend({
  name: 'Tracking',
  components: {
    LoadingFullscreen,
    MainTrackingMobile,
    MainTrackingDesktop,
    NoPhone,
    IconAlert,
    TrackingSupportButton,
  },
  data() {
    return {
      seguimientoData: null as null | SeguimientoData,
      eventos: [] as Evento[],
      trackerPositions: [] as TrackerPosition[],
      carActualPosition: null as null | CarActualPosition,
      minutesLeft: null as number | null,
      sseEventSource: null as null | EventSource,
      seguimientoDataFetched: false,
      error: '',
      fetched: false,
    };
  },
  computed: {
    pedidoPublicId(): string {
      return this.$route.params.pedidoPublicId;
    },
    isEndedByDriver(): boolean {
      const lastEvent = this.eventos[this.eventos.length - 1];
      if (!lastEvent) return false;
      const paradaIndex = lastEvent.parada as number;
      const ultimaParada = paradaIndex === (this.seguimientoData?.paradas.length ?? 0) - 1;
      const isArribado = lastEvent.type === 'arribado';
      return isArribado && ultimaParada;
    },
    lastEvent(): Evento | undefined {
      return this.eventos[this.eventos.length - 1];
    },
    isMobile(): boolean {
      return this.$store.getters.isMobile;
    },
    mappedParadas(): Direccion[] {
      return this.seguimientoData?.paradas.map(({ dir }) => dir) ?? [];
    },
    isRecorridoReal(): boolean {
      return !(this.lastEvent?.type === 'circulando' && this.lastEvent.parada === 0);
    },
  },
  mounted() {
    // Initial fetchs...
    this.fetchSeguimiento();
    this.turnOnSSEListener();

    const userProperties = getUserProperties();

    this.$addUserId(userProperties.username);

    this.$addUserProperties({ ...userProperties });

    this.$logEvent('seguimiento', { accion_seguimiento: 'ingresar_seguimiento' });
  },
  methods: {
    turnOnSSEListener(): void {
      const URL = `${INSERVER_BASE_URL}pedidos/sse/v1/pedido/seguimiento`;

      if (this.sseEventSource) {
        this.disconnect();
      }

      this.sseEventSource = new EventSource(`${URL}/${this.pedidoPublicId}`);

      this.sseEventSource.onmessage = (event) => {
        const data = JSON.parse(event.data) as EventoSeguimientoSSE;
        this.updateTrackingDataFromSSE(data);
      };

      this.sseEventSource.onerror = (error) => {
        console.error('Error en la conexión SSE:', error); // eslint-disable-line no-console
        this.disconnect();
      };
    },
    updateTrackingDataFromSSE(data: EventoSeguimientoSSE): void {
      this.updateEventos(data);
      this.updateTrackerPosition(data);
      this.carActualPosition = mapEventoSSEToCarActualPosition(data);
    },
    updateEventos(data: EventoSeguimientoSSE): void {
      const type = mapDriverEventIdToEventType(data.current.subEvento);
      const { parada } = data.current;

      if (type !== this.lastEvent?.type || parada !== this.lastEvent?.parada
      ) {
        const eventoData = mapEventoSSEToEvento(data);
        this.eventos.push(eventoData);

        if (eventoData.type === 'arribado' && parada !== undefined) {
          this.updateParadaData(data);
        }
      }
    },
    updateParadaData(data: EventoSeguimientoSSE): void {
      const paradaIndex = data.current.parada;
      if (paradaIndex == null || !this.seguimientoData) return;

      const parada = this.seguimientoData.paradas.find(
        (p) => p.secuencia === paradaIndex + 1,
      );
      if (!parada) return;

      parada.dir = {
        ...parada.dir,
        lat: data.current.lat,
        lon: data.current.lon,
      };
    },
    updateTrackerPosition(data: EventoSeguimientoSSE): void {
      if (data.current.parada === 0) return;

      const newPosition = mapEventoSSEToTrackerPosition(data);
      const lastPosition = this.trackerPositions[this.trackerPositions.length - 1];

      if (newPosition.lat !== lastPosition?.lat || newPosition.lon !== lastPosition?.lon) {
        this.trackerPositions.push(newPosition);
      }
    },
    fetchSeguimiento(): void {
      if (this.isEndedByDriver) return;
      get('/pedidos/seguimiento/$pedidoPublicId/v1/info', { pedidoPublicId: this.pedidoPublicId })
        .then(({ data }) => {
          this.eventos = data.eventos;
          this.trackerPositions = data.history;
          this.seguimientoData = data;
        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          this.error = 'Ha ocurrido un error al recuperar datos del seguimiento.';
          this.disconnect();
        }).finally(() => {
          this.seguimientoDataFetched = true;
        });
    },
    fetchMinutesLeft(): void {
      this.minutesLeft = null;
      const { lastEvent } = this;
      if (!lastEvent) return;
      const paradaIndex = lastEvent.parada;
      if (paradaIndex === undefined) return;
      const { carActualPosition } = this;
      if (!carActualPosition) return;
      const parada = this.seguimientoData?.paradas[paradaIndex];
      if (!parada) return;

      const req: DireccionesDistanciasReq = {
        lat1: carActualPosition.lat,
        lon1: carActualPosition.lon,
        lat2: parada.dir.lat,
        lon2: parada.dir.lon,
      };
      get('/direcciones/distancias/$lat1,$lon1:$lat2,$lon2/', req)
        .then((e) => e.data)
        .then((data) => {
          this.minutesLeft = Math.floor(data.durationInSeconds / 60.0);
        }).catch((_) => {
          this.minutesLeft = null;
        });
    },
    disconnect(): void {
      if (this.sseEventSource) {
        this.sseEventSource.close();
        this.sseEventSource = null;
      }
    },
  },
  watch: {
    lastEvent(val: Evento | undefined, oldVal: Evento | undefined) {
      const type = val?.type;
      const parada = val?.parada;

      if (type === 'finalizado' && parada === (this.seguimientoData?.paradas.length ?? 0) - 1) {
        this.disconnect();
        this.fetchSeguimiento();
      }
    },
    carActualPosition(val: null | CarActualPosition) {
      this.fetchMinutesLeft();
    },
    isEndedByDriver(newVal: boolean) {
      if (newVal) {
        this.disconnect();
        this.carActualPosition = null;
      }
    },
  },
  beforeDestroy() {
    this.disconnect();
  },
});
